import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { COUNTRY_CODES } from './CountryCodesList';

/**
 * Phone Property - Allows selecting default country code for phone field
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PhoneProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'tel') {
    return null;
  }
  const countryCode = field.countryCode || 'US';
  const selectedCountry = COUNTRY_CODES.find(c => c.code === countryCode) || COUNTRY_CODES[0];
  return /*#__PURE__*/_jsxs("div", {
    className: "property-section",
    children: [/*#__PURE__*/_jsx("label", {
      className: "section-label",
      children: "Phone Settings"
    }), /*#__PURE__*/_jsx("div", {
      className: "phone-config-section",
      children: /*#__PURE__*/_jsxs("div", {
        className: "property-item",
        children: [/*#__PURE__*/_jsx("label", {
          className: "property-label",
          children: "Default Country Code"
        }), /*#__PURE__*/_jsx("select", {
          value: countryCode,
          onChange: e => updateField(selectedField, {
            countryCode: e.target.value
          }),
          className: "property-input",
          children: COUNTRY_CODES.map(country => /*#__PURE__*/_jsxs("option", {
            value: country.code,
            children: [country.flag, " ", country.dialCode, " - ", country.name]
          }, country.code))
        })]
      })
    })]
  });
};